import React, { RefObject, useRef } from "react";
import { CSSTransition } from "react-transition-group";

import { easings } from "@apps/viewer/src/ts/config";

/**
 * Specification of the transition enter duration in milliseconds.
 */
const ENTER_DURATION = 400;

/**
 * Specification of the transition exit duration in milliseconds.
 */
const EXIT_DURATION = 200;

/**
 * Simple css transition that'll fade and scale the content into view the first
 * time the page is being opened.
 */
// tslint:disable-next-line variable-name no-reserved-keywords
export const ProgressionPromptFade: React.FC<{
  in?: boolean;
  children: (ref: RefObject<any>) => React.ReactNode;
}> = (props) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <CSSTransition
      {...props}
      mountOnEnter
      unmountOnExit
      timeout={{
        enter: ENTER_DURATION,
        exit: EXIT_DURATION,
      }}
      classNames="progressionPrompt"
      nodeRef={ref}
    >
      <>
        {props.children(ref)}

        <style jsx global>{`
          .progressionPrompt-enter,
          .progressionPrompt-appear {
            opacity: 0.001;
          }

          .progressionPrompt-enter-active,
          .progressionPrompt-appear-active {
            opacity: 1;
            transition: opacity ${ENTER_DURATION}ms linear;
          }

          .progressionPrompt-enter > :global(dialog),
          .progressionPrompt-appear > :global(dialog) {
            transform: translate(-50%, -50%) scale(0.5);
          }

          .progressionPrompt-enter-active > :global(dialog),
          .progressionPrompt-appear-active > :global(dialog) {
            transform: translate(-50%, -50%) scale(1);
            transition: transform ${ENTER_DURATION * 0.9}ms
              ${easings.inOutQuart};
          }

          .progressionPrompt-exit {
            opacity: 1;
          }

          .progressionPrompt-exit-active {
            opacity: 0.001;
            transition: opacity ${EXIT_DURATION}ms linear;
          }

          .progressionPrompt-exit-done {
            opacity: 0;
          }
        `}</style>
      </>
    </CSSTransition>
  );
};
